import { InsuranceApplyResultCard } from '../estimateResult/estimateResult/insuranceApplyResultCard';
import { OutlinedButton } from '../util/button';
import { InsuranceResultInfoType } from '@/types/bodyAndPaint';

interface RepairItemHeaderFieldProps {
  onCheckImage: () => void;
  isInsurance: boolean;
  insurance: InsuranceResultInfoType;
}
export const RepairItemHeaderField = ({
  onCheckImage,
  isInsurance,
  insurance,
}: RepairItemHeaderFieldProps) => {
  return (
    <div className={'repair-item-select-header'}>
      <div className={'header-field'}>
        <div className={'header-label'}>
          <span>{'修理依頼内容の選択'}</span>
        </div>
        <div className={'header-button'}>
          <OutlinedButton
            onClick={onCheckImage}
            label={'修理箇所の画像を確認'}
          />
        </div>
      </div>
      {isInsurance && <InsuranceApplyResultCard info={insurance} />}
    </div>
  );
};
